export default {

    SET_CLEARING_MODEL (state, value){
        state.clearingModels = value;
    },

    SET_ENTITY(state, entity) {
        state.entityUid = entity.uid;
    },

    SET_ENTITY_MODEL_NAME(state, entityModelName) {
        state.entityModelName = entityModelName;
    },

    SET_ENTITY_MODEL_KEY(state, entityModelKey) {
        state.entityModelKey = entityModelKey;
    },

    LOGIN_USER(state, {first_name, last_name, uid, token, email}) {
        state.user.authenticated = true;
        state.user.email = email;
        state.user.first_name = first_name;
        state.user.last_name = last_name;
        state.user.uid = uid;
        state.user.token = token;
        state.user.tokenTimeout = false;
    },

    LOGOUT_USER(state, {isTimeout = false}) {
        state.user.authenticated = false;
        state.user.email = '';
        state.user.token = null;
        state.user.first_name = '';
        state.user.last_name = '';
        state.user.uid = '';
        state.user.tokenTimeout = isTimeout;
    },

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-auth/mutations.js
// module id = null
// module chunks = 